(function (module){
    'use strict';


    module.controller('profileCtrl', function (usersApi, $mdToast, _user) {

        // should be done on the API site
        if (_user && _user.password) delete _user.password;

        var ctrl = this;
        ctrl.user = _user;

        // Profile
        ctrl.profile = {
            firstName: ctrl.user.firstName,
            lastName: ctrl.user.lastName,
            company: ctrl.user.company
        };
        ctrl.orgProfile = angular.copy(ctrl.profile);

        ctrl.profileSave = function () {

            usersApi
                .updateProfile(ctrl.user._id, ctrl.profile)
                .then(function (response) {

                    ctrl.orgProfile = angular.copy(ctrl.profile);
                    ctrl.profileForm.$setPristine();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Profile Details Saved')
                            .position('top right')
                            .hideDelay(3000)
                    );

                }, function (error) {
                    console.log('error', error);
                });

        };

        ctrl.profileReset = function () {
            ctrl.profile = angular.copy(ctrl.orgProfile);
            ctrl.profileForm.$setPristine();
        };

        // Access Details
        ctrl.accessDetails = {
            email: ctrl.user.email
        };
        ctrl.orgAccessDetails = angular.copy(ctrl.accessDetails);

        ctrl.accessDetailsSave = function () {

            usersApi
                .updateAccessDetails(ctrl.user._id, ctrl.accessDetails)
                .then(function (response) {

                    ctrl.orgAccessDetails = angular.copy(ctrl.accessDetails);
                    ctrl.accessDetailsForm.$setPristine();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Access Details Saved')
                            .position('top right')
                            .hideDelay(3000)
                    );

                }, function (error) {
                    console.log('error', error);
                });

        };

        ctrl.accessDetailsReset = function () {
            ctrl.accessDetails = angular.copy(ctrl.orgAccessDetails);
            ctrl.accessDetailsForm.$setPristine();
        };

    });

})(angular.module('rocket.components'));
